import { connect } from 'react-redux';
import {
  getTranscriptsList,
  getCloudSearchTranscriptsList,
  setTranscriptsFilter,
  setTranscriptsOrder,
  resubmitTranscript,
} from '@actions/transcripts';
import { requestTranscriptCompletionEmail } from '@actions/attendees';
import { resetConference } from '@actions/conference';
import { isAttendee, isSuperAdmin, isAnalyst } from '@selectors/authentication';
import {
  selectList,
  fromTranscripts as from,
  selectIsFetching,
  selectPagination,
  selectFilters,
  selectIsCloudSearchResults,
} from '@selectors/dashboard';
import DashboardPage from './DashboardPage';

const mapStateToProps = (state) => ({
  list: selectList(from(state)),
  isCloudSearchResults: selectIsCloudSearchResults(from(state)),
  isFetching: selectIsFetching(from(state)),
  ...selectPagination(from(state)),
  ...selectFilters(from(state)),
  showTranscripts: true,
  isAttendee: isAttendee(state),
  isAnalyst: isAnalyst(state),
  isSuperAdmin: isSuperAdmin(state),
});

const mapDispatchToProps = {
  requestTranscriptCompletionEmail,
  getDashboardList: getTranscriptsList,
  setFilterField: setTranscriptsFilter,
  setOrder: setTranscriptsOrder,
  getCloudSearchTranscriptsList,
  resubmitTranscript,
  resetConference,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardPage);



// WEBPACK FOOTER //
// ./components/pages/DashboardPage/Transcripts.js